export const postProcessEnv = (env) => {
    if (env.production == null) {
        env.production = ['prd', 'stg'].indexOf(env.build.deployment?.toLowerCase()) >= 0;
    }
    if (env.hmr == null) {
        env.hmr = env.build.deployment == null;
    }
};
